// removed by extract-text-webpack-plugin
module.exports = {"content":"_2fNlSkvCZjPyAeJ7031IjX","image":"_15OSipXgmdXmFAEoVhagzr","empty":"q2v1Km1ArXtOZAArqkSrB","details":"_27VPR-bLY1-vYpB5WPg1Pj","info":"_3HhXDOioKjgmdh0CLf79O1","label":"_2-4hnpESBz0FuAnM2W5Fd","title":"_372TLugCtUkFCzRQ1gus-p","description":"Q6aW5xwLJxcrDhNzWh7en","productMeta":"_3y9BqnRilKp0i8NlNP6yEZ","buttonClose":"_3QO96mFrmN73WocJ0T6R8d"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Item/SeeMoreModal/SeeMoreModal.scss
 ** module id = 736
 ** module chunks = 0
 **/